import { render, staticRenderFns } from "./PlaylistExercisesItem.vue?vue&type=template&id=825e6a32&scoped=true"
import script from "./PlaylistExercisesItem.vue?vue&type=script&lang=js"
export * from "./PlaylistExercisesItem.vue?vue&type=script&lang=js"
import style0 from "./PlaylistExercisesItem.vue?vue&type=style&index=0&id=825e6a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e6a32",
  null
  
)

export default component.exports